<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR OCUPACIÓN</h1>
            <div class="title-lists">
                {{ selectedProfession?.outsider?.identificationCode }} -
                {{ selectedProfession?.outsider?.name }}
                {{ selectedProfession?.outsider?.lastName }}
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="editProfessionForm" (ngSubmit)="updateProfession()">
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Ocupación</mat-label>
                            <mat-select matInput placeholder="Ocupación" formControlName="name">
                                <mat-option *ngFor="let o of occupation"
                                [value]="o.value">
                                {{o.value}}
                            </mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                editProfessionForm.get('name')?.hasError(
                                'required')">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Lugar donde labora</mat-label>
                            <input matInput placeholder="Donde trabaja o Dinamiza" formControlName="companyName"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editProfessionForm
                                        .get('companyName')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="isLeader">¿Es lider?</mat-checkbox>
                        </section>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Tipo de lider</mat-label>
                            <mat-select matInput placeholder="Tipo de lider" formControlName="leaderRole">
                                <mat-option *ngFor="let l of leadertype" [value]="l.value">{{ l.label }}</mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editProfessionForm
                                        .get('leaderRole')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                </button>
                <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
                    <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                </button>
            </form>
        </div>
    </div>
</div>
